<!-- 表1填写 -->

<template>
  <div class="tabCage table1">
    <i class="el-icon-refresh-left"></i>
    <i class="el-icon-refresh-right"></i>
    <div class="tabTtl">
      <span>表 1-1：基本情况表</span>
      <el-button type="primary" size="small" @click="getcode201HistoryData">导入历史数据</el-button>
    </div>
    <div class="tip-div">
      <span class="tip-red"
        >工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。</span
      >
    </div>
    <div class="headBar">
      <span>工商营业执照或事业法人证书信息（请按照营业执照或事业法人证书上的信息填写）</span>
    </div>
    <el-form ref="paramCk" :model="params" :rules="rules">
      <div class="editArea">
        <table>
          <tr>
            <td class="edName">
              <!-- <span class="requiretag">*</span> -->
              单位名称：
            </td>
            <td class="edInpBig">
              <el-form-item prop="publishName" :inline-message="true">
                <el-input v-model="params.publishName" size="small" placeholder="请输入单位名称"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">统一社会信用代码：</td>
            <td class="edInp">
              <el-form-item prop="usccNum" :inline-message="true">
                <el-input
                  v-model="params.usccNum"
                  size="small"
                  placeholder="请输入工商营业执照上“统一社会信用代码”项"></el-input>
              </el-form-item>
            </td>
          </tr>
          <!-- <tr>
            <td class="edName">名称：</td>
            <td class="edInp">
              <el-form-item prop="usccOrgName" :inline-message="true">
                <el-input
                  style="width: 600px"
                  v-model="params.usccOrgName"
                  size="small"
                  placeholder="请输入工商营业执照上“名称”项"></el-input>
              </el-form-item>
            </td>
          </tr> -->
          <tr>
            <td class="edName">类型：</td>
            <td class="edInp">
              <el-form-item prop="usccType" :inline-message="true">
                <el-select v-model="params.usccType" size="small" placeholder="请选择营业执照上“类型”项">
                  <el-option v-for="item in dicDats['C001']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">住所：</td>
            <td class="edInp">
              <el-form-item prop="residence" :inline-message="true">
                <el-input v-model="params.residence" size="small" placeholder="请输入工商营业执照上“住所”项"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">法定代表人：</td>
            <td class="edInp">
              <el-form-item prop="faren" :inline-message="true">
                <el-input
                  v-model="params.faren"
                  size="small"
                  placeholder="请输入工商营业执照上“法定代表人”项"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName"> 注册资本或开办资金（万元）：</td>
            <td class="edInp">
              <el-form-item prop="yyzzZczb" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  :controls="false"
                  v-model="params.yyzzZczb"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">成立日期：</td>
            <td class="edInp">
              <el-form-item prop="clDate" :inline-message="true">
                <el-date-picker
                  @change="changeHandle(1)"
                  v-model="params.clDate"
                  align="right"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">营业日期：</td>
            <td class="edInp areaTime">
              <el-form-item prop="startYyDate" :inline-message="true">
                <el-date-picker
                  @change="changeHandle(2)"
                  v-model="params.startYyDate"
                  value-format="yyyy-MM-dd"
                  placeholder="开始日期"
                  size="small">
                </el-date-picker>
              </el-form-item>
              <span class="midSpan">至</span>
              <el-date-picker
                @change="changeHandle(3)"
                v-model="params.endYyDate"
                value-format="yyyy-MM-dd"
                placeholder="结束日期"
                size="small">
              </el-date-picker>
              <div class="tips">注：营业执照有效期为长期的，无须填写结束日期</div>
            </td>
          </tr>
          <tr>
            <td class="edName">经营范围或业务范围：</td>
            <td class="edInpTextArea">
              <el-form-item prop="yyfw" :inline-message="true">
                <el-input
                  type="textarea"
                  :rows="8"
                  v-model="params.yyfw"
                  placeholder="请输入工商营业执照上“经营范围”项"
                  size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">登记日期：</td>
            <td class="edInp">
              <el-form-item prop="djDate" :inline-message="true">
                <el-date-picker
                  @change="changeHandle(4)"
                  v-model="params.djDate"
                  align="right"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">证照编号：</td>
            <td class="edInp">
              <!-- <el-form-item prop="usccCode" :inline-message="true"> -->
              <el-input
                v-model="params.usccCode"
                placeholder="请输入工商营业执照上“证照编号”项"
                size="small"></el-input>
              <div class="tips">没有请填写“无”</div>
              <!-- </el-form-item> -->
            </td>
          </tr>
          <tr>
            <td class="edName uploadLine">上传营业执照或事业法人证书：</td>
            <td class="edInp">
              <span style="color: red; line-height: 24px"
                >注：图片上传时要注意图片是否全部旋转到正确的方向，不得出现竖版图片横放的情况。点击图片大图模式下可以调整方向。
                <br />
                上传文件格式为JPEG/PNG，文件大小不超过10M。
              </span>
              <Upbtn :ableSure="imgId" @upFileId="fileTdSet" needTip="no" />
            </td>
          </tr>
        </table>
      </div>
      <div class="headBar">
        <span>单位基本信息</span>
      </div>

      <div class="editArea">
        <table>
          <tr>
            <td class="edName">企业性质：</td>
            <td class="edInp edSelect">
              <el-form-item prop="nature" :inline-message="true">
                <el-select v-model="params.nature" size="small" placeholder="请选择企业性质">
                  <el-option v-for="item in dicDats['C001']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="CompanyNatureMap[params.nature] == '其他'" prop="otherNature" :inline-message="true">
                <el-input size="small" v-model="params.otherNature" placeholder="若企业性质为“其他”，请输入"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">是否为独立法人：</td>
            <td class="edInp">
              <el-form-item prop="isIndependentLP" :inline-message="true">
                <el-select v-model="params.isIndependentLP" @change="layChange" size="small" placeholder="请选择">
                  <el-option v-for="item in dicDats['C018']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <div class="tip-red">以音像电子业务为主体业务的独立法人单位填写"是"，其他单位填写"否"</div>
            </td>
          </tr>
          <tr v-if="layDasion == 1">
            <td class="edName">独立法人单位类型：</td>
            <td class="edInp">
              <el-form-item prop="unitType" :inline-message="true">
                <el-select v-model="params.unitType" size="small" placeholder="请选择单位类型">
                  <el-option v-for="item in dicDats['C019']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr v-if="layDasion == 1">
            <td class="edName">独立法人隶属关系：</td>
            <td class="edInp">
              <el-form-item prop="independentLPSituation" :inline-message="true">
                <el-select v-model="params.independentLPSituation" size="small" placeholder="请选择隶属关系">
                  <el-option v-for="item in dicDats['C003']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr v-if="layDasion == 2">
            <td class="edName">非独立法人隶属关系：</td>
            <td class="edInp">
              <el-form-item prop="nonIndependentLPSituation" :inline-message="true">
                <el-select v-model="params.nonIndependentLPSituation" size="small" placeholder="请选择隶属关系">
                  <el-option v-for="item in dicDats['C004']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">地址：</td>
            <td class="edInp">
              <el-form-item prop="publishAddr" :inline-message="true">
                <el-input v-model="params.publishAddr" size="small" placeholder="请输入单位地址"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">邮政编码：</td>
            <td class="edInp">
              <el-form-item prop="publishPostalcode" :inline-message="true">
                <el-input v-model="params.publishPostalcode" size="small" placeholder="请输入单位邮编"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">联系人：</td>
            <td class="edInp">
              <el-form-item prop="publishLinkman" :inline-message="true">
                <el-input v-model="params.publishLinkman" size="small" placeholder="请输入单位联系人"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">联系电话：</td>
            <td class="edInp">
              <el-form-item prop="publishTel" :inline-message="true">
                <el-input v-model="params.publishTel" size="small" placeholder="请输入单位联系人座机号码"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">手机号：</td>
            <td class="edInp">
              <el-form-item prop="publishPhone" :inline-message="true">
                <el-input v-model="params.publishPhone" size="small" placeholder="请输入单位联系人手机号码"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">单位职工总数：</td>
            <td class="edInp">
              <el-form-item :inline-message="true">
                <el-input-number
                  controls-position="right"
                  v-model="params.workers"
                  :min="0"
                  :controls="false"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">
              从事<span v-if="pressType == 1">音像</span> <span v-else-if="pressType == 2">电子</span>业务人员数：
            </td>
            <td class="edInp">
              <el-form-item :inline-message="true">
                <el-input-number
                  controls-position="right"
                  v-model="params.businessWorkers"
                  :min="0"
                  :controls="false"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">其他人员数：</td>
            <td class="edInp">
              <el-form-item :inline-message="true">
                <el-input-number
                  controls-position="right"
                  v-model="params.otherWorkers"
                  :min="0"
                  :controls="false"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">资产总额（万元）：</td>
            <td class="edInp">
              <el-form-item :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :disabled="layDasion == 2"
                  v-model="params.totalAssets"
                  :min="0"
                  :precision="2"
                  :controls="false"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">负债总额（万元）：</td>
            <td class="edInp">
              <el-form-item :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :disabled="layDasion == 2"
                  v-model="params.totalLiabilities"
                  :min="0"
                  :precision="2"
                  :controls="false"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">备注：</td>
            <td class="edInpTextArea">
              <el-form-item prop="remark" :inline-message="true">
                <el-input type="textarea" :rows="2" v-model="params.remark" placeholder="" size="small"></el-input>
              </el-form-item>
              <div class="tips">
                注：请填写出版单位其他需要说明的相关信息，譬如注册资金为美元、法人变更在进行中等情况，如没有不填写
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="headBar">
        <span>申报人信息</span>
      </div>
      <div class="editArea">
        <table>
          <tr>
            <td class="edName">申报人：</td>
            <td class="edInp">
              <el-input v-model="declare.personnel" size="small" placeholder="请输入申报人"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系方式：</td>
            <td class="edInp">
              <el-input v-model="declare.contact" size="small" placeholder="请输入申报人联系方式"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">申报时间：</td>
            <td class="edInp">
              <el-input v-model="params.updatedAt" size="small" :disabled="true"></el-input>
            </td>
          </tr>
        </table>
      </div>
    </el-form>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
      <el-button v-if="pubStatus == 0" type="primary" @click="editSave('paramCk')" size="small" :disabled="submiting">
        <span v-if="submiting">提交中</span>
        <span v-else>保存</span>
        <i v-if="submiting" class="el-icon-loading"></i>
      </el-button>
    </div>
  </div>
</template>

<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsEt1";
import {
  tabUpdate1,
  tabRead1, // 信息读取
  code201HistoryData, // 基本情况表 - 导入历史数据
} from "@/api/pressRole/pressRole";
import { detFile } from "@/api/account";
import Upbtn from "@/views/components/uploadCards";
// import Upbtn from '@/views/components/upload';

export default {
  components: {
    Upbtn,
  },
  data() {
    return {
      pressType: this.$route.query.pressType,
      params: bsParams,
      rules: paramsRule,
      dicDats: {},
      isNot: {},
      submiting: false,
      layDasion: 2,
      imgId: "",

      CompanyNatureMap: {},
      declare: {
        personnel: "",
        contact: "",
      },
      pubStatus: 0,
    };
  },
  methods: {
    editSave: function (name) {
      let that = this;
      this.$refs[name].validate((valid) => {
        if (valid) {
          that.params.publishId = that.$route.query.pressId;
          that.params.publishMaterialId = that.$route.query.mtId;
          if (that.declare.personnel == "") {
            that.$message.error("申报人姓名必填");
            return;
          }
          // var pattern = /^1[0-9]{10}$/;
          // if (!pattern.test(that.declare.contact)) {
          //   that.$message.error('申报人手机号格式错误');
          //   return
          // }
          if (that.declare.contact == "") {
            that.$message.error("申报人联系方式必填");
            return;
          }

          let byyzzZczb = that.params.yyzzZczb > 1500000;
          let bZczb = that.params.registeredCapital > 1500000;
          if (byyzzZczb || bZczb) {
            that.$confirm("请确认注册资本填写的是否正确。", "提示", {
              confirmButtonText: "确定", //确认按钮的文字
              showCancelButton: false, //是否显示取消按钮
              showClose: false, //是否显示关闭按钮
              closeOnClickModal: false, //是否可以通过点击空白处关闭弹窗
              type: "error",
            });
            return;
          }

          let msg = "请再次确认页面中所输入的金额单位为万元。";
          that
            .$confirm(msg, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              tabUpdate1({
                data: that.params,
                organizationPersonnel: that.declare,
                // 身份验证要用
                publishMaterialId: this.params.publishMaterialId,
                // code:
              })
                .then((response) => {
                  let tipCode = response.payload.pbasic.code;
                  let tipMessage = response.payload.pbasic.message;

                  that.submiting = false;
                  if (tipCode == -1) {
                    that.$message.error(`保存错误: ${tipMessage}`);
                  } else {
                    that.$message({
                      message: "保存成功！",
                      type: "success",
                    });

                    // that.editAfter(response);
                    that.goBack();
                  }
                })
                .catch((error) => {
                  that.submiting = false;
                });
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },

    editAfter: function (resDat) {
      // 后台把值从.data里边带回来了.hsj
      if (this.imgId != resDat.payload.pbasic.data.yyzzId) {
        detFile({
          id: this.imgId,
        })
          .then((response) => {})
          .catch((error) => {});
      }
    },

    dictInit: function () {
      let nameArr = ["C001", "C018", "C019", "C003", "C004"];
      let newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "arr",
      });
      let vm = this;
      newPromise.then((result) => {
        vm.dicDats = result;
        vm.isNot = vm.$store.getters.dictionary["C018"];
        vm.CompanyNatureMap = vm.$store.getters.dictionary["C001"];
        for (let key in this.isNot) {
          if (vm.isNot[key] == "否") {
            vm.params.isIndependentLP = key;
          }
        }
      });
    },

    tabReEdit: function () {
      console.log("信息读取", this.$route.query.mtId);
      tabRead1({
        publishMaterialId: this.$route.query.mtId,
      }).then((response) => {
        this.params = response.pbasic;
        this.params.publishMaterialId = this.$route.query.mtId;

        this.imgId = response.pbasic.yyzzId;

        this.declare.publishMaterialId = this.$route.query.mtId;
        this.declare.contact = response.pOrganizationPersonnel.contact;
        this.declare.personnel = response.pOrganizationPersonnel.personnel;
        this.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
        this.layChange();
      });
    },

    fileTdSet: function (id) {
      this.params.yyzzId = id;
      this.imgId = id;
    },

    layChange: function () {
      if (this.isNot[this.params.isIndependentLP] == "是") {
        this.layDasion = 1;
        this.params.nonIndependentLPSituation = "";
      } else {
        this.layDasion = 2;
        this.params.unitType = "";
        this.params.independentLPSituation = "";
        this.params.registeredCapital = 0;
        this.params.totalAssets = 0;
        this.params.totalLiabilities = 0;
      }
    },

    changeHandle: function (code) {
      let newDate = new Date().getTime();
      if (code == 1) {
        if (new Date(this.params.clDate).getTime() > newDate) {
          this.params.clDate = "";
          this.$message.error("成立时间不可大于当前日期！");
        } else {
          if (!this.params.startYyDate) {
            this.params.startYyDate = this.params.clDate;
          }
        }
      } else if (code == 2) {
        if (new Date(this.params.startYyDate).getTime() > newDate) {
          this.params.startYyDate = "";
          this.$message.error("营业开始时间不可大于当前日期！");
        } else if (this.params.endYyDate) {
          if (new Date(this.params.endYyDate).getTime() < new Date(this.params.startYyDate).getTime()) {
            this.params.startYyDate = "";
            this.$message.error("营业开始时间不可大于营业结束日期！");
          }
        }
      } else if (code == 3) {
        if (this.params.startYyDate) {
          if (new Date(this.params.endYyDate).getTime() < new Date(this.params.startYyDate).getTime()) {
            this.params.endYyDate = "";
            this.$message.error("营业结束日期不能小于营业开始日期！");
          }
        }
      } else if (code == 4) {
        if (new Date(this.params.djDate).getTime() > newDate) {
          this.params.djDate = "";
          this.$message.error("营业登记时间不可大于当前日期！");
        }
      }
    },
    // 返回上一页
    goBack: function () {
      this.$router.go(-1);
    },
    //获取历史导入数据
    getcode201HistoryData: function () {
      let that = this;
      this.imgId = "";
      const loading = this.$loading({
        lock: true,
        text: "导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      code201HistoryData({
        publishMaterialId: this.$route.query.mtId,
      })
        .then((response) => {
          loading.close();
          delete response.pbasic.id;
          // 旧数据打底，历史数据覆盖，旧ID删除，新publishMaterialId替换 - Hsj
          that.params = { ...that.params, ...response.pbasic, publishMaterialId: that.$route.query.mtId };
          that.imgId = response.pbasic.yyzzId;

          // zym.删除申报时间
          delete that.params.updatedAt;
          // if (response.pOrganizationPersonnel !== null && response.pOrganizationPersonnel != undefined) {
          //   that.declare.contact = response.pOrganizationPersonnel.contact;
          //   that.declare.personnel = response.pOrganizationPersonnel.personnel;
          //   // that.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
          // }
          that.layChange();
        })
        .catch((error) => {
          that.submiting = false;
        });
    },
    // //加载loading
    // openFullScreen2() {
    //   const loading = this.$loading({
    //     lock: true,
    //     text: 'Loading',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(0, 0, 0, 0.7)'
    //   });
    //   setTimeout(() => {
    //     loading.close();
    //   }, 2000);
    // }
  },
  created: function () {
    this.dictInit();
    console.log("this.$route.query.pgress=", this.$route.query.pgress);
    this.pubStatus = this.$route.query.pubStatus;
    if (this.$route.query.pgress == 2) {
      this.tabReEdit();
    }
  },

  beforeDestroy: function () {
    for (let key in this.params) {
      this.params[key] = "";
    }
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.table1 {
  .tabTtl {
    .el-button {
      float: right;
    }
  }

  margin-top: 0;

  .areaTime .el-form-item {
    display: inline-block;
  }

  .areaTime .midSpan {
    margin: 0px 6px;
  }

  .edSelect .el-form-item {
    display: inline-block;
  }

  .upBtn {
    display: inline-block;
  }

  .editArea table .edName {
    width: 210px;
  }

  .icons {
    padding-left: 35px;

    img {
      display: block;
      margin: 6px 0 0 20px;
      float: left;
      cursor: pointer;
    }

    .el-button {
      margin-left: 20px;
    }
  }
}

.table1 .tips {
  display: inline-block;
  margin-left: 12px;
}

.table1 .uploadLine {
  vertical-align: text-top;
  padding-top: 5px;
}

.table1 .numLine {
  padding-bottom: 15px;
}

.table1 .numInp {
  display: inline-block;
  margin-bottom: 12px;
}

.table1 .numInp .inpName {
  display: inline-block;
  width: 180px;
  text-align: right;
}

.table1 .numInp .inpText {
  display: inline-block;
  padding-left: 12px;
}

.table1 .numInp .inpText input {
  border-radius: 0;
}

.el-date-editor {
  border-radius: 0;
}

// .table1 .el-textarea {
//   width: 635px;
// }

// .table1 .edInp .el-input-number {
//   width: 300px;
// }

.table1 .spMake .el-form-item {
  display: inline-block;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// table1.vue?89d1b2a2